import React from "react";
import { useNavigate, Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { useState, useEffect } from "react";
import MenuHeader from "../../../InitialPage/Sidebar/MenuHeader.jsx";
import { useSearchParams } from "react-router-dom";
import { base_api_url } from "../../../environment.jsx";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { createCheckoutSession } from "../../../services/stripeService";
import DeliveryAddress from "../../../core/modals/menus/deliveryaddress";
import { Users, Gift, Check, Wallet} from "lucide-react";
import PropTypes from "prop-types";

// ⚠️ MODE : true = Utilise service Stripe direct | false = Nécessite backend
const DEMO_MODE = true;

// ─────────────────────────────────────────────────────────────────────────────
// Sub-components for the Vente à Distance workflow
// ─────────────────────────────────────────────────────────────────────────────

const StepIndicator = ({ step, label, color, status }) => {
  const isDone   = status === 'done';
  const isActive = status === 'active';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, minWidth: 56 }}>
      <div style={{
        width: 36, height: 36, borderRadius: '50%',
        backgroundColor: isDone || isActive ? color : '#e2e8f0',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'all 0.4s ease',
        boxShadow: isActive  ? `0 0 0 5px ${color}22` :
                   isDone    ? `0 2px 10px ${color}55` : 'none',
        border: `2px solid ${isDone || isActive ? color : '#cbd5e1'}`,
      }}>
        {isDone
          ? <Check size={15} color="white" strokeWidth={3} />
          : <span style={{ fontSize: 13, color: isActive ? 'white' : '#94a3b8', fontWeight: 700 }}>{step}</span>
        }
      </div>
      <span style={{
        fontSize: 9, fontWeight: 700, textTransform: 'uppercase',
        letterSpacing: '0.6px',
        color: isDone || isActive ? color : '#94a3b8',
        transition: 'color 0.3s ease',
      }}>{label}</span>
    </div>
  );
};

StepIndicator.propTypes = {
  step:   PropTypes.number.isRequired,
  label:  PropTypes.string.isRequired,
  color:  PropTypes.string.isRequired,
  status: PropTypes.oneOf(['active', 'done', 'idle']).isRequired,
};

const DeliveryStepCard = ({ isComplete, onOpenModal, addressData }) => (
  <div
    onClick={!isComplete ? onOpenModal : undefined}
    style={{
      backgroundColor: isComplete ? '#f0f9ff' : '#ffffff',
      border: `1.5px solid ${isComplete ? '#2196F3' : '#bfdbfe'}`,
      borderLeft: '4px solid #2196F3',
      borderRadius: 14,
      padding: '14px 16px',
      marginBottom: 12,
      cursor: isComplete ? 'default' : 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: isComplete
        ? '0 4px 14px rgba(33,150,243,0.15)'
        : '0 2px 6px rgba(33,150,243,0.07)',
      position: 'relative',
      overflow: 'hidden',
    }}
    onMouseEnter={(e) => {
      if (!isComplete) {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 8px 20px rgba(33,150,243,0.22)';
        e.currentTarget.style.backgroundColor = '#eff6ff';
      }
    }}
    onMouseLeave={(e) => {
      if (!isComplete) {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 6px rgba(33,150,243,0.07)';
        e.currentTarget.style.backgroundColor = '#ffffff';
      }
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      {/* Icône */}
      <div style={{
        width: 46, height: 46, borderRadius: 13,
        backgroundColor: isComplete ? '#2196F3' : '#dbeafe',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 22, flexShrink: 0,
        transition: 'all 0.35s ease',
        boxShadow: isComplete ? '0 4px 10px rgba(33,150,243,0.35)' : 'none',
      }}>
        {isComplete ? '✅' : '🚚'}
      </div>

      {/* Texte */}
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
          <span style={{ fontWeight: 700, fontSize: 13, color: '#1e40af' }}>
            Adresse de livraison
          </span>
          <span style={{
            fontSize: 8, fontWeight: 800, letterSpacing: '0.5px',
            backgroundColor: '#fee2e2', color: '#dc2626',
            padding: '2px 7px', borderRadius: 4, textTransform: 'uppercase',
          }}>OBLIGATOIRE</span>
        </div>
        <span style={{ fontSize: 12, color: isComplete ? '#1d4ed8' : '#94a3b8', lineHeight: 1.4 }}>
          {isComplete
            ? (addressData?.adresse || addressData?.rue || 'Adresse renseignée ✓')
            : 'Indiquez où livrer votre commande'}
        </span>
      </div>

      {/* Flèche / Check */}
      <div style={{
        width: 30, height: 30, borderRadius: '50%',
        backgroundColor: isComplete ? '#2196F3' : '#e0f2fe',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, transition: 'all 0.3s ease',
      }}>
        {isComplete
          ? <Check size={14} color="white" strokeWidth={3} />
          : <span style={{ color: '#2196F3', fontSize: 16, fontWeight: 700, lineHeight: 1 }}>›</span>
        }
      </div>
    </div>

    {/* Lien modifier quand complet */}
    {isComplete && (
      <div
        onClick={(e) => { e.stopPropagation(); onOpenModal(); }}
        style={{
          marginTop: 10, paddingTop: 8,
          borderTop: '1px dashed #bfdbfe',
          display: 'flex', alignItems: 'center', gap: 5,
          cursor: 'pointer', color: '#2196F3', fontSize: 11, fontWeight: 600,
        }}
      >
        <span>✏️</span>
        <span>Modifier l&apos;adresse</span>
      </div>
    )}
  </div>
);

DeliveryStepCard.propTypes = {
  isComplete:  PropTypes.bool.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  addressData: PropTypes.shape({
    adresse: PropTypes.string,
    rue:     PropTypes.string,
  }),
};

DeliveryStepCard.defaultProps = {
  addressData: null,
};

const LoyaltyStepCard = ({ isChecked, onToggle }) => (
  <div style={{
    backgroundColor: isChecked ? '#fff7ed' : '#ffffff',
    border: `1.5px solid ${isChecked ? '#FF6A3D' : '#fed7aa'}`,
    borderLeft: '4px solid #FF6A3D',
    borderRadius: 14,
    padding: '14px 16px',
    marginBottom: 16,
    transition: 'all 0.35s ease',
    boxShadow: isChecked
      ? '0 4px 18px rgba(255,106,61,0.2)'
      : '0 2px 6px rgba(255,106,61,0.06)',
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      {/* Icône */}
      <div style={{
        width: 46, height: 46, borderRadius: 13,
        backgroundColor: isChecked ? '#FF6A3D' : '#ffedd5',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 22, flexShrink: 0,
        transition: 'all 0.35s ease',
        boxShadow: isChecked ? '0 4px 10px rgba(255,106,61,0.38)' : 'none',
      }}>🎁</div>

      {/* Texte */}
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
          <span style={{ fontWeight: 700, fontSize: 13, color: isChecked ? '#c2410c' : '#92400e' }}>
            Programme Fidélité
          </span>
          <span style={{
            fontSize: 8, fontWeight: 800, letterSpacing: '0.5px',
            backgroundColor: '#dcfce7', color: '#16a34a',
            padding: '2px 7px', borderRadius: 4, textTransform: 'uppercase',
          }}>OPTIONNEL</span>
        </div>
        <span style={{ fontSize: 12, color: isChecked ? '#c2410c' : '#94a3b8', lineHeight: 1.4 }}>
          {isChecked ? 'Vous gagnez des points sur cet achat ✨' : 'Activez pour gagner des points'}
        </span>
      </div>

      {/* Toggle iOS-style */}
      <div
        onClick={onToggle}
        role="switch"
        aria-checked={isChecked}
        style={{
          width: 46, height: 26, borderRadius: 13,
          backgroundColor: isChecked ? '#FF6A3D' : '#e2e8f0',
          position: 'relative', cursor: 'pointer',
          transition: 'background-color 0.3s ease',
          flexShrink: 0,
          boxShadow: isChecked ? '0 2px 8px rgba(255,106,61,0.45)' : 'inset 0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{
          position: 'absolute',
          top: 3,
          left: isChecked ? 23 : 3,
          width: 20, height: 20, borderRadius: '50%',
          backgroundColor: 'white',
          transition: 'left 0.28s cubic-bezier(0.4,0,0.2,1)',
          boxShadow: '0 1px 5px rgba(0,0,0,0.22)',
        }} />
      </div>
    </div>

    {/* Message contextuel quand fidélité activée */}
    {isChecked && (
      <div style={{
        marginTop: 10, paddingTop: 9,
        borderTop: '1px dashed #fed7aa',
        display: 'flex', alignItems: 'center', gap: 6,
        animation: 'si-fadeIn 0.3s ease',
      }}>
        <Gift size={12} color="#FF6A3D" />
        <span style={{ fontSize: 11, color: '#c2410c', fontWeight: 500 }}>
          Renseignez votre email ci-dessous pour recevoir vos points
        </span>
      </div>
    )}
  </div>
);

LoyaltyStepCard.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onToggle:  PropTypes.func.isRequired,
};

const SpecificInstruction = () => {
  const MySwal = withReactContent(Swal);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [showDeliveryAddressModal, setShowDeliveryAddressModal] = useState(false);
  const [deliveryAddressData, setDeliveryAddressData] = useState(null);
  const [tableType, setTableType] = useState(1); // 1: Classique, 2: Livraison, 3: QR Client
  const [stripeEnabled, setStripeEnabled] = useState(false);
  const [restaurantStripeKeys, setRestaurantStripeKeys] = useState(null); // Stocké en mémoire seulement
  
  const restau = searchParams.get("r") || localStorage.getItem('last_restaurant_id');
  const table = searchParams.get("t") || localStorage.getItem('table_id');
  const devise = JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.devise || JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise;
  const [isLoyaltyChecked, setIsLoyaltyChecked] = useState(false);

  const toggleLoyalty = () => {
    setIsLoyaltyChecked((prev) => !prev);
  };

  // 🔄 Vérifier que le restaurant correspond aux données en session
  useEffect(() => {
    const lastRestaurantId = localStorage.getItem('last_restaurant_id');
    const currentRestaurantId = restau?.toString();
    
    if (lastRestaurantId && currentRestaurantId && lastRestaurantId !== currentRestaurantId) {
      console.log('⚠️ Restaurant différent détecté dans specific-instruction');
      window.location.href = `/homemenu?r=${restau}&t=${table}`;
      return;
    }
  }, [restau, table]);

  
  // Fetch table type information
  useEffect(() => {
    const fetchTableType = async () => {
      // Try to get from localStorage first
      const storedTableType = localStorage.getItem('type_table');
      if (storedTableType) {
        setTableType(parseInt(storedTableType));
        console.log('📦 Table type from localStorage:', storedTableType);
        return;
      }
      
      // If not in localStorage, fetch from API
      if (table) {
        try {
          const response = await axios.get(`${base_api_url}api/tables/${table}`);
          const fetchedType = response.data.table?.type_table || 1;
          setTableType(fetchedType);
          localStorage.setItem('type_table', fetchedType.toString());
          console.log('🔍 Table type fetched from API:', fetchedType);
        } catch (error) {
          console.error('Erreur lors de la récupération du type de table:', error);
          setTableType(1); // Default to Classique
          localStorage.setItem('type_table', '1');
        }
      }
    };
    
    fetchTableType();
  }, [table]);

  // Check if restaurant has Stripe configured
  useEffect(() => {
    const checkRestaurantStripe = async () => {
      if (!restau) {
        console.log('⚠️ No restaurant ID available');
        return;
      }

      try {
        console.log(`🔍 Checking Stripe configuration for restaurant ${restau}...`);
        
        // Récupérer le token depuis sessionStorage
        const client = JSON.parse(sessionStorage.getItem('client'));
        const token = client?.access_token;
        
        if (!token) {
          console.warn('⚠️ No access token available');
          setStripeEnabled(false);
          setRestaurantStripeKeys(null);
          return;
        }
        
        const response = await axios.get(`${base_api_url}api/restaurant/${restau}/stripe`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        if (response.status === 200 && response.data?.stripe) {
          const { pk_stripe, sk_stripe } = response.data.stripe;
          
          // Vérifier que les clés sont bien présentes et non vides
          if (pk_stripe && sk_stripe && pk_stripe.trim() !== '' && sk_stripe.trim() !== '') {
            console.log('✅ Stripe enabled for restaurant:', response.data.nom_restaurant);
            setStripeEnabled(true);
            
            // ⚠️ TEMPORAIRE: Stocké en mémoire (state) uniquement, pas dans localStorage
            // En production, ces clés ne devraient JAMAIS être exposées au client
            setRestaurantStripeKeys({
              pk_stripe,
              sk_stripe,
              nom_restaurant: response.data.nom_restaurant
            });
          } else {
            console.log('⚠️ Stripe keys are empty or invalid');
            setStripeEnabled(false);
            setRestaurantStripeKeys(null);
          }
        } else {
          console.log('⚠️ No Stripe configuration found for this restaurant');
          setStripeEnabled(false);
          setRestaurantStripeKeys(null);
        }
      } catch (error) {
        if (error.response?.status === 404) {
          console.log('ℹ️ Restaurant does not have Stripe configured');
        } else if (error.response?.status === 401) {
          console.log('⚠️ Unauthorized - Invalid or expired token');
        } else {
          console.error('❌ Error checking Stripe configuration:', error);
        }
        setStripeEnabled(false);
        setRestaurantStripeKeys(null);
      }
    };

    checkRestaurantStripe();
  }, [restau]);

  
  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({
          ...prev,
          [name]: value
      }));
  };

  const total = localStorage.getItem('total');
  const Total = Number(total);
  
  const Quantity = localStorage.getItem('quantite');
  const cartQuantity = Number(Quantity);

  const [formData, setFormData] = useState({
    "notes": "",
    "prenom_client": "",
    "nom_client": "",
    "telephone": "",
    "email": "",
    "client_ref": "",
    "moyen_paiement": "cash"
  });

  
  // Delivery address states déjà déclarés plus haut
  
  console.log("Total ", Quantity);
  
  // Function to save delivery address
  const saveDeliveryAddress = async (orderId) => {
    try {
      if (!deliveryAddressData) {
        console.log('⚠️ No delivery address data to save');
        return;
      }
      
      const dataToSubmit = {
        ...deliveryAddressData,
        id_commande: orderId
      };
      
      console.log('📦 Saving delivery address:', dataToSubmit);
      
      const response = await axios.post(`${base_api_url}api/adresse`, dataToSubmit);
      
      if (response.status === 200 || response.status === 201) {
        console.log('✅ Delivery address saved successfully');
        MySwal.fire({
          icon: "success",
          // title: "Adresse enregistrée !",
          text: "Votre adresse de livraison a bien été enregistrée.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
});
      }
      
    } catch (error) {
      console.error('❌ Error saving delivery address:', error);
      
      // Show error but don't block the order
      MySwal.fire({
        icon: "warning",
        // title: "Attention",
        text: "Votre commande est validée mais il y a eu un problème avec l'enregistrement de l'adresse. Notre équipe vous contactera.",
        confirmButtonText: "OK"
      });
    }
  };

  // 🎭 MODE DÉMO : Redirection directe vers Stripe Checkout (sans formulaire frontend)
  const handleStripePaymentDemo = async (client) => {
    try {
      // Confirmation avant redirection
      const confirmation = await MySwal.fire({
        // title: '💳 Paiement par Carte Bancaire',
        html: `
          <div style="text-align: center; padding: 20px;">
            <div style="background: #f8f9fa; padding: 20px; border-radius: 12px; margin-bottom: 20px;">
              <div style="display: flex; justify-content: space-between; margin-bottom: 12px;">
                <span style="color: #666; font-size: 14px;">Commande:</span>
                <strong style="font-size: 14px;">${client.reference}</strong>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <span style="color: #666; font-size: 14px;">Montant à payer:</span>
                <strong style="color: #FF6A3D; font-size: 22px;">${Total} ${devise || 'XOF'}</strong>
              </div>
            </div>
            <p style="color: #666; font-size: 14px; margin-top: 15px;">
              🔐 Vous allez être redirigé vers Stripe pour saisir vos informations de carte de manière sécurisée.
            </p>
          </div>
        `,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: '🔐 Proceder au paiement',
        cancelButtonText: '❌ Annuler',
        width: '500px',
      });

      if (!confirmation.isConfirmed) {
        return;
      }

      // Afficher un écran de traitement
      MySwal.fire({
        // title: '🔐 Connexion à Stripe...',
        html: `
          <div style="text-align: center;">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem; margin: 20px 0;">
              <span class="sr-only">Chargement...</span>
            </div>
            <p style="color: #666; margin-top: 15px;">Création de la session de paiement...</p>
          </div>
        `,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          MySwal.showLoading();
        }
      });

      try {
        console.log('🔥 ÉTAPE 1 : Création session Stripe Checkout...');
        
        // Récupérer r et t depuis localStorage ou URL
        const restaurantParam = restau || localStorage.getItem('restaurant_id');
        const tableParam = table || localStorage.getItem('table_id');
        
        // Sauvegarder dans localStorage pour ne pas les perdre
        if (restau) localStorage.setItem('restaurant_id', restau);
        if (table) localStorage.setItem('table_id', table);
        
        console.log('📍 Paramètres:', { r: restaurantParam, t: tableParam });
        
        // APPEL RÉEL À STRIPE API avec les clés du restaurant
        const sessionData = await createCheckoutSession({
          reference: client.reference,
          amount: Total,
          currency: devise || 'xof',
          notes: formData.notes,
          success_url: `${window.location.origin}/end-order?r=${restaurantParam}&t=${tableParam}&session_id={CHECKOUT_SESSION_ID}`,
          cancel_url: `${window.location.origin}/specific-instruction?r=${restaurantParam}&t=${tableParam}`,
          customer_email: 'client.demo@restaurant.com', // Email fictif pour la démo
          sk_stripe: restaurantStripeKeys?.sk_stripe // ⚠️ Passer la clé en paramètre (temporaire - attente backend)
        });

        console.log('✅ ÉTAPE 2 : Session créée avec succès:', {
          sessionId: sessionData.sessionId,
          url: sessionData.url
        });

        // Mettre à jour la commande avec statut_paiement = 2 (en attente de paiement)
        const updateResponse = await axios.put(`${base_api_url}api/commandes/${client.reference}`, {
          moyen_paiement: 'card',
          notes: formData.notes,
          statut: 10,
          statut_paiement: 2 // 2 = En attente de paiement Stripe
        });

        // Save delivery address if type_table = 2 (before redirect to Stripe)
        if (tableType === 2 && deliveryAddressData) {
          const commandeId = updateResponse.data?.commande?.id_commande || updateResponse.data?.id_commande;
          if (commandeId) {
            await saveDeliveryAddress(commandeId);
          } else {
            console.warn('⚠️ id_commande not found in response, using client.reference as fallback');
            await saveDeliveryAddress(client.reference);
          }
        }

        // Stocker les infos dans localStorage pour référence
        localStorage.setItem('stripe_session', JSON.stringify({
          sessionId: sessionData.sessionId,
          reference: client.reference,
          amount: Total,
          currency: devise || 'xof',
          timestamp: new Date().toISOString(),
          r: restaurantParam,
          t: tableParam
        }));

        MySwal.close();

        // Afficher succès
        MySwal.fire({
          icon: "success",
          // title: "Session créée !",
          html: `
            <div style="text-align: center;">
              <p style="color: #666; margin: 10px 0;">
                Redirection vers Stripe Checkout...
              </p>
              <p style="color: #28a745; font-weight: bold; font-size: 18px; margin: 15px 0;">
                ${Total} ${devise || 'XOF'}
              </p>
            </div>
          `,
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });

        console.log('🔥 ÉTAPE 3 : Redirection vers Stripe Checkout...');

        // 🔥 REDIRECTION VERS VRAI STRIPE CHECKOUT
        setTimeout(() => {
          window.location.href = sessionData.url;
        }, 2000);

      } catch (error) {
        console.error('❌ Erreur lors de la création de la session:', error);
        
        MySwal.close();
        
        MySwal.fire({
          icon: "error",
          // title: "Erreur de paiement",
          html: `
            <div style="text-align: center;">
              <p style="color: #dc3545; font-weight: bold; margin: 15px 0;">
                ${error.message || 'Impossible de créer la session de paiement'}
              </p>
              <div style="background: #f8d7da; padding: 12px; border-radius: 8px; margin: 15px 0; border-left: 4px solid #dc3545;">
                <p style="margin: 0; color: #721c24; font-size: 13px;">
                  Veuillez réessayer ou contacter le support.
                </p>
              </div>
            </div>
          `,
          confirmButtonText: 'Réessayer',
          confirmButtonColor: '#FF6A3D',
        });
      }
    } catch (error) {
      console.error("Erreur paiement Stripe:", error);
      MySwal.fire({
        icon: "error",
        // title: "Erreur",
        text: "Une erreur est survenue. Veuillez réessayer.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  //  PRODUCTION : Fonction réelle avec backend Stripe (désactivée en démo)
  const handleStripePaymentProduction = async (client) => {
    // Cette fonction sera utilisée quand DEMO_MODE = false
    try {
      const { loadStripe } = await import("@stripe/stripe-js");
      const stripePromise = loadStripe('pk_test_51SeieaHzgzAgXup3Y6DVeJqIzaQjzPlyXZWnOCOkSW8PXJ49gYwG8T10x25v8IethhquW97WjhqPNviMlHicAmDh00feT92hJr');
      
      MySwal.fire({
        // title: 'Préparation du paiement...',
        html: 'Redirection vers Stripe Checkout',
        allowOutsideClick: false,
        didOpen: () => {
          MySwal.showLoading();
        }
      });

      const response = await axios.post(`${base_api_url}stripe/create-checkout-session`, {
        reference: client.reference,
        amount: Total,
        currency: devise || 'xof',
        notes: formData.notes,
        success_url: `${window.location.origin}/end-order?r=${restau}&t=${table}&session_id={CHECKOUT_SESSION_ID}`,
        cancel_url: `${window.location.origin}/specific-instruction?r=${restau}&t=${table}`
      });

      if (response.status === 200 || response.status === 201) {
        const { sessionId } = response.data;
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({ sessionId });

        if (error) {
          console.error('Erreur Stripe:', error);
          MySwal.fire({
            icon: "error",
            // title: "Erreur de paiement",
            text: error.message,
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
          });
        }
      }
    } catch (error) {
      console.error("Erreur Stripe:", error);
      MySwal.fire({
        icon: "error",
        // title: "Erreur de paiement",
        text: "Impossible de créer la session de paiement.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
      });
    }
  };

 const handlePaiement = React.useCallback(async () => {
    try {
      const client = JSON.parse(sessionStorage.getItem("client"));
      
      if (!client?.reference) {
        MySwal.fire({
          icon: "error",
          // title: "Erreur de session",
          text: "Votre session a expiré. Veuillez recommencer votre commande.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });
        return;
      }
      
      // Check if delivery address is required (type_table = 2) and not provided yet
      if (tableType === 2 && !deliveryAddressData) {
        setShowDeliveryAddressModal(true);
        return;
      }

      // Si paiement par carte, utiliser la simulation en mode démo
      if (formData.moyen_paiement === "card") {
        // Mode démo : simulation complète côté frontend
        if (DEMO_MODE) {
          await handleStripePaymentDemo(client);
        } else {
          // Mode production : utiliser le vrai backend Stripe
          await handleStripePaymentProduction(client);
        }
        
        // Note: L'adresse de livraison est déjà sauvegardée dans handleStripePaymentDemo
        // avant la redirection vers Stripe
        
        return;
      }
       if (formData.email && !validateEmail(formData.email)) {
           MySwal.fire({
          icon: "error",
          // title: "Erreur de session",
          text: "Veuillez entrer une adresse email valide.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });        
          return;
        }

        let clientRef = "";
        if (formData.email?.trim() && validateEmail(formData.email)) {
          clientRef = formData.email;
        } else if (formData.telephone?.trim() && formData.telephone) {
          clientRef = formData.telephone;
        }
        
      // Sinon, traiter le paiement en espèce normalement
      const playload = {
        "moyen_paiement": formData.moyen_paiement,
        "notes": formData.notes,
        "statut": 10,
        "statut_paiement": 1 , // 1 = Paiement en espèces (à la livraison)
        ...(formData.prenom_client?.trim() && { prenom_client: formData.prenom_client }),
        ...(formData.nom_client?.trim() && { nom_client: formData.nom_client }),
        ...(formData.telephone?.trim() && { telephone: formData.telephone }),
        ...(formData.email?.trim() && { email: formData.email }),
        ...(clientRef && { client_ref: clientRef })
      };

      const response = await axios.put(`${base_api_url}api/commandes/${client.reference}`, {
          ...playload
      });
      console.log("handlePaiement:", response.data);
      // Handle successful responses (200, 201)
      if (response.status === 200 || response.status === 201) {
        console.log("handlePaiement:", response.data);
        
        // Save delivery address if type_table = 2
        if (tableType === 2 && deliveryAddressData) {
          // Use id_commande from the response data
          const commandeId = response.data?.commande?.id_commande || response.data?.id_commande;
          if (commandeId) {
            await saveDeliveryAddress(commandeId);
          } else {
            console.warn('⚠️ id_commande not found in response, using client.reference as fallback');
            await saveDeliveryAddress(client.reference);
          }
        }

        // Show success notification
        MySwal.fire({
          icon: "success",
          // title: "Commande validée !",
          text: "Votre commande a été soumise avec succès.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });

        // Navigate to end order page
        navigate(`/end-order?r=${restau}&t=${table}`);
      }
      
    } catch (error) {
      console.error("Erreur lors du paiement :", error);
      
//       let errorTitle = "Erreur de validation";
      let errorMessage = "Impossible de valider votre commande. Veuillez réessayer.";
      
      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;
        
        switch (status) {
          case 400:
//             errorTitle = "Données invalides";
            errorMessage = errorData?.message || "Les informations de paiement sont invalides.";
            break;
          
          case 401:
//             errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Veuillez recommencer votre commande.";
            break;
          
          case 404:
//             errorTitle = "Commande introuvable";
            errorMessage = "Votre commande n'a pas été trouvée. Veuillez recommencer.";
            break;
          
          case 409:
//             errorTitle = "Commande déjà validée";
            errorMessage = "Cette commande a déjà été validée.";
            break;
          
          case 422:
//             errorTitle = "Commande non valide";
            errorMessage = errorData?.message || "Votre commande ne peut pas être validée dans son état actuel.";
            break;
          
          case 500:
//             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
            break;
          
          case 503:
//             errorTitle = "Service indisponible";
            errorMessage = "Le service de commande est temporairement indisponible.";
            break;
          
          default:
//             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite.";
        }
      } else if (error.request) {
//         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }
      
      // Show error notification
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    }
  }, [formData, deliveryAddressData, tableType, restaurantStripeKeys, navigate, restau, table, MySwal, saveDeliveryAddress, handleStripePaymentDemo, handleStripePaymentProduction]);

  return (
  <>
    <MenuHeader restauId={restau} Table={table} showBackButton={true} cartQuantity={cartQuantity} />
    <div style={{ padding: '20px', minHeight: 'calc(100vh - 60px)', fontFamily: 'Arial, sans-serif', backgroundColor: '#f5f5f5' }}>
      
      {/* ── Workflow Vente à Distance (mode livraison uniquement) ─────────────── */}
      {tableType === 2 ? (
        <div style={{ marginBottom: 4 }}>
          {/* Keyframes injectés une seule fois */}
          <style>{`
            @keyframes si-fadeIn {
              from { opacity: 0; transform: translateY(-6px); }
              to   { opacity: 1; transform: translateY(0); }
            }
          `}</style>

          {/* ── En-tête contextuel ── */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: 8,
            marginBottom: 14, padding: '8px 12px',
            backgroundColor: '#f8fafc',
            borderRadius: 10, border: '1px solid #e2e8f0',
          }}>
            <span style={{ fontSize: 15 }}>🛵</span>
            <div>
              <p style={{ margin: 0, fontSize: 12, fontWeight: 700, color: '#334155' }}>
                Mode Vente à Distance
              </p>
              <p style={{ margin: 0, fontSize: 10, color: '#94a3b8' }}>
                Complétez les étapes ci-dessous pour finaliser votre commande
              </p>
            </div>
          </div>

          {/* ── Barre de progression (stepper) ── */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: 0,
            marginBottom: 16, padding: '0 6px',
          }}>
            <StepIndicator
              step={1} label="Livraison" color="#2196F3"
              status={deliveryAddressData ? 'done' : 'active'}
            />
            {/* Connecteur dégradé animé */}
            <div style={{
              flex: 1, height: 3, borderRadius: 2, margin: '0 4px',
              background: deliveryAddressData
                ? 'linear-gradient(90deg, #2196F3 0%, #FF6A3D 100%)'
                : 'linear-gradient(90deg, #2196F3 30%, #e2e8f0 100%)',
              transition: 'background 0.6s ease',
            }} />
            <StepIndicator
              step={2} label="Fidélité" color="#FF6A3D"
              status={isLoyaltyChecked ? 'done' : 'idle'}
            />
          </div>

          {/* ── Étape 1 : Adresse de livraison ── */}
          <DeliveryStepCard
            isComplete={!!deliveryAddressData}
            onOpenModal={() => setShowDeliveryAddressModal(true)}
            addressData={deliveryAddressData}
          />

          {/* ── Étape 2 : Programme Fidélité ── */}
          <LoyaltyStepCard
            isChecked={isLoyaltyChecked}
            onToggle={toggleLoyalty}
          />
        </div>
      ) : (
        /* ── Mode classique / QR : bouton fidélité standalone ── */
        <button
          type="button"
          onClick={toggleLoyalty}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            borderRadius: '12px',
            transition: 'all 0.3s ease',
            border: isLoyaltyChecked ? '1px solid #ea580c' : '1px solid #e2e8f0',
            backgroundColor: isLoyaltyChecked ? '#ea580c' : 'white',
            color: isLoyaltyChecked ? 'white' : '#334155',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
            marginBottom: '16px',
            cursor: 'pointer',
          }}
        >
          <div style={{
            padding: '8px', borderRadius: '8px',
            backgroundColor: isLoyaltyChecked ? 'rgba(255,255,255,0.2)' : '#fff7ed',
            color: isLoyaltyChecked ? 'white' : '#ea580c',
          }}>
            <Gift size={16} />
          </div>
          <div style={{ flex: 1, textAlign: 'left' }}>
            <p style={{ fontSize: '11px', fontWeight: 600, margin: 0 }}>Programme Fidélité</p>
            <p style={{ fontSize: '11px', margin: '4px 0 0', opacity: 0.8 }}>Gagnez des points sur cet achat</p>
          </div>
          <div style={{
            width: '20px', height: '20px', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            border: isLoyaltyChecked ? '1px solid white' : '1px solid #cbd5e1',
            backgroundColor: isLoyaltyChecked ? 'white' : 'transparent',
          }}>
            {isLoyaltyChecked && <Check size={14} color="#ea580c" />}
          </div>
        </button>
      )}

      {/* Coordonnées : toujours visible en mode classique/QR,
          uniquement si fidélité activée en mode vente à distance */}
      {(tableType !== 2 || isLoyaltyChecked) && (
        <div
          className="gap-2"
          style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '12px 16px',
            border: tableType === 2 ? '1.5px solid #fed7aa' : '1px solid #f1f5f9',
            boxShadow: tableType === 2
              ? '0 4px 14px rgba(255,106,61,0.12)'
              : '0 1px 2px rgba(0,0,0,0.05)',
            marginBottom: '16px',
            animation: tableType === 2 ? 'si-fadeIn 0.35s ease' : 'none',
          }}
        >
          {/* En-tête section */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: '8px',
            marginBottom: '16px', padding: '8px 12px',
            backgroundColor: tableType === 2 ? '#fff7ed' : '#f5f5f5',
            borderRadius: '8px', width: '100%',
          }}>
            {tableType === 2
              ? <Gift size={16} color="#FF6A3D" />
              : <Users size={16} color="#94a3b8" />
            }
            <h2 style={{
              fontWeight: 600, fontSize: '11px', margin: 0, display: 'block',
              color: tableType === 2 ? '#c2410c' : '#64748b',
              textTransform: 'uppercase', letterSpacing: '0.5px',
            }}>
              {tableType === 2 ? 'Infos Programme Fidélité' : 'Coordonnées (Optionnel)'}
            </h2>
          </div>

          {/* Champs */}
          <div style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: 600, fontSize: 15, marginBottom: 4, display: 'block' }}>Prénom</label>
              <input
                type="text"
                name="prenom_client"
                value={formData.prenom_client}
                onChange={handleChange}
                placeholder="Jean"
                className="form-control"
                style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', fontSize: 15, width: '100%' }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: 600, fontSize: 15, marginBottom: 4, display: 'block' }}>Nom</label>
              <input
                type="text"
                name="nom_client"
                value={formData.nom_client}
                onChange={handleChange}
                placeholder="Dupont"
                className="form-control"
                style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', fontSize: 15, width: '100%' }}
              />
            </div>
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontWeight: 600, fontSize: 15, marginBottom: 4, display: 'block' }}>Téléphone</label>
            <input
              type="text"
              name="telephone"
              value={formData.telephone}
              onChange={handleChange}
              className="form-control"
              placeholder="678764523"
              style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', fontSize: 15, width: '100%' }}
            />
          </div>
          <div style={{ marginBottom: 20 }} className={`transition-colors duration-300 ${isLoyaltyChecked ? 'bg-orange-50/30' : ''}`}>
            <label style={{ fontWeight: 600, fontSize: 15, marginBottom: 4, display: 'block' }}>
              Email{' '}
              {(tableType === 2 || isLoyaltyChecked) && (
                <span className="text-orange-600 ml-1 font-black text-[8px]">● REQUIS</span>
              )}
            </label>
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="test@gmail.com"
              className="form-control"
              style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', fontSize: 15, width: '100%' }}
            />
          </div>
        </div>
      )}


      {/* Commentaire - Version maquette */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '12px 16px',
        border: '1px solid #f5f5f5',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        marginBottom: '16px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '8px'
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          <span style={{
            fontWeight: 600, 
            fontSize: '11px',
            margin: 0, 
            display: 'block', 
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Commentaire
          </span>
        </div>
        <textarea
          placeholder="Instructions de livraison..."
          name="notes"
          value={formData.notes}
          onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
          style={{
            width: '100%',
            fontSize: '12px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            padding: '8px 12px',
            border: 'none',
            outline: 'none',
            resize: 'none',
            minHeight: '50px',
            fontFamily: 'inherit',
            color: '#334155'
          }}
        />
      </div>

      <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            marginBottom: '16px',
            paddingBottom: '12px',
          }}>
            <Wallet size={20} color="#666" />
            <h2 style={{ fontWeight: 600, fontSize: 15, margin: 0 }}>paiement</h2>
          </div>
      
        <div style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          padding: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          marginTop: '20px'
        }}>
          
              <div className="table-responsive dataview">
                <table className="table dashboard-recent-products">
                  <tbody>                    
                    <tr>
                      <td className="productimgname">
                          <ImageWithBasePath
                            src="assets/img/products/paiement-espece.png"
                            alt=" "
                          />Paiement en caisse
                      </td>
                      <td className="no-sort">
                        <label className="radio">
                          <input 
                          name="payment_method"
                          value="cash"
                          onChange={(e) =>
                            {setFormData({ ...formData, moyen_paiement: e.target.value }); console.log("moyen_paiement " + formData.moyen_paiement);}
                          }
                          type="radio"
                          checked={formData.moyen_paiement=="cash"}
                          />
                        </label>
                      </td>
                    </tr>
                    {stripeEnabled && (
                      <tr>
                        <td className="productimgname">
                            <ImageWithBasePath
                              src="assets/img/products/carteBancaire.jpg"
                              alt=" "
                            />
                          Par carte Bancaire
                        </td>
                      <td className="no-sort">
                          <label className="radio">
                            <input type="radio" name="payment_method" value="card"
                            onChange={(e) =>
                              {setFormData({ ...formData, moyen_paiement: e.target.value }); console.log("moyen_paiement " + formData.moyen_paiement);}
                            }
                            checked={formData.moyen_paiement=="card"}
                            />
                          </label>
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td className="productimgname ">
                          <ImageWithBasePath
                            src="/assets/img/products/orange.png"
                            alt="Orange Money"
                          />
                          Orange Money
                      </td>
                      <td className="no-sort">
                        <label className="radio">
                          <input type="radio" name="payment_method" value="orangeMoney"
                          disabled="true"
                          />                  
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td className="productimgname">
                          <ImageWithBasePath
                            src="/assets/img/products/mtn.png"
                            alt=" "
                          />MTNMomo
                      </td>
                      <td className="no-sort">
                        <label className="radio">
                          <input type="radio" name="payment_method" value="MTNMomo"
                          disabled="true"
                          />
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
           
          </div>
           <div className="d-flex justify-content-center"> 
              <Link
                to="#"
                className="btn text-primary modal-footer-btn"
                style={{
                  borderRadius: "10px",
                  padding: "10px 20px",
                  fontSize: "1rem",
                  fontWeight: "500",
                  marginTop: "30px",
                  marginBottom: "30px",
                  backgroundColor: '#FFF4EF',
                  color: '#FF4500',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  width: '90%',
                  maxWidth: '400px',
                }}
                onClick={handlePaiement}
              >
                <span type="submit">Valider ma commande</span>
                <span style={{ color: '#FF4500', fontWeight: 'bold' }}>• {Total} {devise}</span>
              </Link>
            </div>
          </div>
       
    
    {/* Delivery Address Modal */}
    <DeliveryAddress
      show={showDeliveryAddressModal}
      onClose={() => {
        setShowDeliveryAddressModal(false);
      }}
      onSubmit={(addressData) => {
        // Store address data
        setDeliveryAddressData(addressData);
        setShowDeliveryAddressModal(false);
        
        console.log('✅ Delivery address collected:', addressData);
        
        // Show confirmation - l'utilisateur doit cliquer à nouveau sur "Valider ma commande"
        MySwal.fire({
          icon: "success",
          // title: "Adresse validée !",
          text: "Cliquez sur 'Valider ma commande' pour finaliser.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
        });
      }}
      initialData={deliveryAddressData}
    />
  </>
  );
}

export default SpecificInstruction;